import { createFileRoute } from '@tanstack/react-router'
import Login from '~containers/samsung.smart-things/login'
import setOAuth2Params from '~utils/app/set-oauth2-params'

interface SearchParams {
  client_id: string
  response_type: 'code'
  redirect_uri: string
  state: string
  callback_uri?: string
}

export const Route = createFileRoute('/accounts/v1/$company/$app/sign-in')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    // 필수 필드 검증
    if (
      typeof search.client_id !== 'string' ||
      search.response_type !== 'code' ||
      typeof search.redirect_uri !== 'string' ||
      typeof search.state !== 'string'
    ) {
      throw new Error('Invalid access')
    }

    const res = {
      client_id: search.client_id,
      response_type: 'code',
      redirect_uri: search.redirect_uri,
      state: search.state,
      callback_uri: typeof search.callback_uri === 'string' ? search.callback_uri : undefined,
    }
    setOAuth2Params(res)
    return res as SearchParams
  },
})

function RouteComponent() {
  /**
   * @TODO: 전역적으로 사용하는 컨테이너인데, 삼성에 너무 매몰되어있음.
   * 이 부분은 로그인 컨테이너를 새로 구성해야함.
   * 현재는 삼성 로그인 페이지를 위한 라우트 처리를 위한 임시 코드임.
   */
  const search = Route.useSearch()

  return (
    <main className="flex flex-col items-center justify-center h-screen">
      <Login
        {...search}
        onSuccess={() => {
          /* nothing to do */
        }}
      />
    </main>
  )
}
